import { useCallback, useEffect, useRef, useState } from 'react'

import { useQueryClient } from '@tanstack/react-query'

type UseHasPianoSDKErrored = () => boolean

const useHasPianoSDKErrored: UseHasPianoSDKErrored = () => {
  const queryClient = useQueryClient()
  const queryCache = queryClient.getQueryCache()
  const unsubscribeFnRef = useRef<() => void>(undefined)

  const [hasPianoSDKErrored, setHasPianoSDKErrored] = useState<boolean>(
    () => !!queryClient.getQueryData<boolean>(['hasPianoSDKErrored']),
  )

  const updateHasPianoSDKErrored = useCallback(
    (args: any) => {
      if (
        ['invalidate'].includes(args?.action?.type) &&
        args.query.queryKey[0] === 'hasPianoSDKErrored'
      ) {
        setHasPianoSDKErrored(
          !!queryClient.getQueryData<boolean>(['hasPianoSDKErrored']),
        )
      }
    },
    [queryClient],
  )

  useEffect(() => {
    unsubscribeFnRef.current = queryCache.subscribe(updateHasPianoSDKErrored)

    return () => {
      if (unsubscribeFnRef.current) {
        unsubscribeFnRef.current()
      }
    }
  }, [updateHasPianoSDKErrored, queryCache])

  return hasPianoSDKErrored
}

export default useHasPianoSDKErrored
